import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { Button } from '@factorialco/factorial-one-react'
import { EmojiAvatar } from '@factorialco/factorial-one-react/dist/experimental'
import { Add } from '@factorialco/factorial-one-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const ScheduleEmptyState = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <Box
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      padding="s200"
      gap="s16"
    >
      <EmojiAvatar emoji="🗓️" size="lg" />
      <Text.Header2>{i18n.t('project_management.planning.empty_state.title')}</Text.Header2>
      <Text.Normal size="300" color="grey700" ellipsis>
        {i18n.t('project_management.planning.empty_state.description')}
      </Text.Normal>
      <Button
        icon={Add}
        label={i18n.t('project_management.planning.empty_state.button_title')}
        size="md"
        variant="default"
        onClick={() => {
          navigate(navigation.projects.fullPath())
        }}
      />
    </Box>
  )
}

export default ScheduleEmptyState
